import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

// Components
import PayPal from './Paypal';
import Stripe from './Stripe';
import PawaPay from './PawaPay';
class PayoutConfirm extends Component {
  static propTypes = {
    previousPage: PropTypes.any.isRequired,
    paymentType: PropTypes.string.isRequired
  };

  render() {
    const { paymentType, previousPage } = this.props;
    if (paymentType === 2) {
      return (
        <ElementsConsumer>
          {({ stripe }) => (
            <Stripe previousPage={previousPage} stripe={stripe} />
          )}
        </ElementsConsumer>
      );
    } else if (paymentType === 3) {
      return <PawaPay previousPage={previousPage} />;
    } else {
      return <PayPal
        previousPage={previousPage}
      />
    }
  }
}

const selector = formValueSelector('PayoutForm');

const mapState = (state) => ({
  paymentType: selector(state, 'paymentType')
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(PayoutConfirm);
